import React from 'react';
import { FiBookOpen, FiCheckCircle, FiClipboard, FiEdit3 } from 'react-icons/fi';
import SummaryCard from './SummaryCard';

const displayRate = (rate) => (rate === null ? '-' : `${rate}%`);

const SummaryGrid = ({ summary }) => (
  <section className="report-panel report-summary" aria-labelledby="report-summary-title">
    <h2 id="report-summary-title">학습 요약</h2>
    <div className="report-summary__grid">
      <SummaryCard title="출석률" value={displayRate(summary.attendance.rate)}
        detail={`${summary.attendance.present} / ${summary.attendance.total}일 출석`}
        rate={summary.attendance.rate} color="#25b96b" icon={<FiCheckCircle />} />
      <SummaryCard title="진도율" value={displayRate(summary.progress.rate)}
        detail={`${summary.progress.completed} / ${summary.progress.total}회 완료`}
        rate={summary.progress.rate} color="#2f7cf6" icon={<FiBookOpen />} />
      <SummaryCard title="과제 이행률" value={displayRate(summary.homework.rate)}
        detail={`${summary.homework.completed} / ${summary.homework.total}건 완료`}
        rate={summary.homework.rate} color="#7455d9" icon={<FiClipboard />} />
      <SummaryCard title="TEST 평균 (OMR)"
        value={summary.tests.average === null ? '-' : `${summary.tests.average}점`}
        detail={summary.tests.completed ? `OMR ${summary.tests.completed}건 채점` : 'OMR 채점 결과 없음'}
        rate={summary.tests.average} color="#f97316" icon={<FiEdit3 />} />
    </div>
  </section>
);

export default SummaryGrid;
